import { useEffect, useState } from "react";
import { useTranslation } from "@/shared/i18n/LocaleProvider";
import { greetingBand } from "@/shared/time/greeting";
import { useTimeZone } from "@/shared/time/TimeZoneProvider";

export function ChatGreeting({ advisorName }: { advisorName: string }) {
  const { t } = useTranslation();
  const zone = useTimeZone();
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    const timer = window.setInterval(() => setNow(new Date()), 60_000);
    return () => window.clearInterval(timer);
  }, []);

  const band = greetingBand(now, zone);
  return (
    <h1 className="m-0 text-center text-xl leading-[1.1] font-medium tracking-[-0.03em] text-(--ink)">
      {t(`chatView.greeting.${band}`)}
      {advisorName ? `, ${advisorName}` : ""}
    </h1>
  );
}
